// @flow
import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent'
import {renderFieldWithAddons as fieldWithAddons} from "./../utils"
import {COMPONENT_CHILDREN} from './../Utils2';

import "./AbstractField.scss"

/**
 * Abstract field
 *
 * Základní komponenta každého input feildu
 *
 * Důvody:
 * - aby se dala později rozšířit o funkcionalitu
 * - pro renderování s addony
 */
class AbstractField extends AbstractReactComponent {

    static PropTypes = {
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
    };

    renderFieldWithAddons = (field: Object, addonsBefore: [?Object, ?Array<Object>], addonsAfter : [?Object, ?Array<Object>]) => {
        return fieldWithAddons(field, addonsBefore, addonsAfter);
    }
}
export default AbstractField;
